import React from 'react';

const T = {
  ink: '#111111',
  muted: '#666660',
  line: '#dedbd3',
  bg: '#fff7ed',
  accent: '#8B2500',
  mono: '"JetBrains Mono", "Courier New", monospace',
};

export function isAlphaLabMode() {
  const mode = import.meta.env?.VITE_MOODS_MODE || 'alpha_lab';
  return String(mode).toLowerCase() === 'alpha_lab';
}

export default function PublicArchiveBanner({ label = 'Archived research record' }) {
  if (!isAlphaLabMode()) return null;
  return (
    <div
      style={{
        borderBottom: `1px solid ${T.line}`,
        background: T.bg,
        color: T.ink,
        fontFamily: T.mono,
      }}
    >
      <div
        style={{
          maxWidth: '1120px',
          margin: '0 auto',
          padding: '10px 24px',
          display: 'grid',
          gap: '4px',
        }}
      >
        <strong style={{ color: T.accent, fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
          {label}
        </strong>
        <span style={{ color: T.muted, fontSize: '12px', lineHeight: 1.5 }}>
          This page is preserved for context while Moods is rebuilt as a private alpha lab. It is not a live trade recommendation or current desk state.
        </span>
      </div>
    </div>
  );
}
